import React from 'react';
import Input from './ui/Input';

const LinkTypeForm = ({ type, data, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-4 animate-in fade-in slide-in-from-bottom-2">
      {(type === 'url' || type === 'instagram' || type === 'facebook' || type === 'linkedin') && (
        <Input 
          label={type === 'url' ? "Website, Social Link, WhatsApp, or YouTube Link" : `${type.charAt(0).toUpperCase() + type.slice(1)} URL`}
          placeholder="https://..." 
          value={data.url || ''} 
          onChange={(e) => handleChange('url', e.target.value)} 
        />
      )}
      
      {type === 'text' && (
        <div>
          <label className="text-sm font-medium text-zinc-400 mb-1 block">Message</label>
          <textarea 
            className="w-full bg-zinc-900/50 border border-zinc-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-red-500 min-h-[120px]"
            placeholder="Enter text..."
            value={data.text || ''}
            onChange={(e) => handleChange('text', e.target.value)}
          />
        </div>
      )}

      {type === 'phone' && (
        <Input 
          label="Phone Number" 
          placeholder="+91 98765 43210" 
          value={data.phone || ''} 
          onChange={(e) => handleChange('phone', e.target.value)} 
        />
      )}

      {type === 'sms' && (
        <>
          <Input 
            label="Phone Number" 
            placeholder="+91..." 
            value={data.smsPhone || ''} 
            onChange={(e) => handleChange('smsPhone', e.target.value)} 
          />
          <Input 
            label="Message" 
            placeholder="Hello..." 
            value={data.smsBody || ''} 
            onChange={(e) => handleChange('smsBody', e.target.value)} 
          />
        </>
      )}

      {type === 'email' && (
        <>
          <Input 
            label="Email" 
            placeholder="hello@..." 
            value={data.email || ''} 
            onChange={(e) => handleChange('email', e.target.value)} 
          />
          <Input 
            label="Subject" 
            placeholder="Inquiry" 
            value={data.emailSubject || ''} 
            onChange={(e) => handleChange('emailSubject', e.target.value)} 
          />
          <div>
            <label className="text-sm font-medium text-zinc-400 mb-1 block">Body</label>
            <textarea 
              className="w-full bg-zinc-900/50 border border-zinc-800 rounded-xl px-4 py-3 text-white min-h-[100px]"
              value={data.emailBody || ''}
              onChange={(e) => handleChange('emailBody', e.target.value)}
            />
          </div>
        </>
      )}

      {type === 'whatsapp' && (
        <>
          <Input 
            label="WhatsApp Number" 
            placeholder="+91..." 
            value={data.waPhone || ''} 
            onChange={(e) => handleChange('waPhone', e.target.value)} 
          />
          <Input 
            label="Message" 
            placeholder="I'm interested..." 
            value={data.waText || ''} 
            onChange={(e) => handleChange('waText', e.target.value)} 
          />
        </>
      )}

      {type === 'location' && (
        <Input 
          label="Address" 
          placeholder="New York, NY" 
          value={data.locationQuery || ''} 
          onChange={(e) => handleChange('locationQuery', e.target.value)} 
        />
      )}

      {type === 'wifi' && (
        <>
          <Input label="SSID" value={data.wifiSsid || ''} onChange={(e) => handleChange('wifiSsid', e.target.value)} />
          <Input label="Password" value={data.wifiPassword || ''} onChange={(e) => handleChange('wifiPassword', e.target.value)} />
          <div className="flex gap-4">
            <select 
              className="bg-zinc-900 border border-zinc-800 rounded-xl px-4 py-3 text-white"
              value={data.wifiType || 'WPA'}
              onChange={(e) => handleChange('wifiType', e.target.value)}
            >
              <option value="WPA">WPA/WPA2</option>
              <option value="WEP">WEP</option>
              <option value="nopass">None</option>
            </select>
            <label className="flex items-center gap-2 text-zinc-300">
              <input 
                type="checkbox" 
                checked={data.wifiHidden || false} 
                onChange={(e) => handleChange('wifiHidden', e.target.checked)} 
              /> Hidden
            </label>
          </div>
        </>
      )}

      {type === 'event' && (
        <>
          <Input label="Event Title" value={data.eventTitle || ''} onChange={(e) => handleChange('eventTitle', e.target.value)} />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input label="Start Date & Time" type="datetime-local" value={data.eventStart || ''} onChange={(e) => handleChange('eventStart', e.target.value)} />
            <Input label="End Date & Time" type="datetime-local" value={data.eventEnd || ''} onChange={(e) => handleChange('eventEnd', e.target.value)} />
          </div>
          <Input label="Location" value={data.eventLocation || ''} onChange={(e) => handleChange('eventLocation', e.target.value)} />
          <div>
            <label className="text-sm font-medium text-zinc-400 mb-1 block">Description</label>
            <textarea 
              className="w-full bg-zinc-900/50 border border-zinc-800 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-red-500 min-h-[100px]"
              placeholder="Event details..."
              value={data.eventDesc || ''}
              onChange={(e) => handleChange('eventDesc', e.target.value)}
            />
          </div>
        </>
      )}

      {type === 'vcard' && (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <Input label="First Name" value={data.vFn || ''} onChange={(e) => handleChange('vFn', e.target.value)} />
            <Input label="Last Name" value={data.vLn || ''} onChange={(e) => handleChange('vLn', e.target.value)} />
          </div>
          <Input label="Mobile" value={data.vPhone || ''} onChange={(e) => handleChange('vPhone', e.target.value)} />
          <Input label="Email" value={data.vEmail || ''} onChange={(e) => handleChange('vEmail', e.target.value)} />
          <Input label="Company" value={data.vOrg || ''} onChange={(e) => handleChange('vOrg', e.target.value)} />
        </div>
      )}
    </div>
  );
};

export default LinkTypeForm;